/**
 * Created by hp on 2017/6/20.
 */
import React,{Component} from 'react';
import {connect} from 'react-redux';

import '../styles/error.css';

class WKError extends Component {
    render() {
        const {error} = this.props;
        return(
            <div style={{width: '100%', height: '100vh', backgroundcolor: '#f0f0f0', position: 'relative'}}>
                <div className="details-none-item">
                    <div className="item__img">
                        <img src={error.img} alt=""/>
                    </div>
                    <div className="item__text">{error.tips}</div>
                    {error.btn &&
                    <a href={error.href} className="item__btn">
                        {error.btn}
                    </a>
                    }
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    error: state.error,
}))(WKError)




// WEBPACK FOOTER //
// ./src/components/WKError.js